export default "__VITE_PUBLIC_ASSET__aae7753a__"